import { IAchPaymentsObj, IBorrowerVenderObj, IDrawAttachmentObj, IHomePaymentsObj, ILoanDrawDetailObj, IPendingApprovalObj, IRequestDrawLoanInfo } from "../../components/interfaces/Borrower";

const getMockHomeDrawRequestsInfolist = async () => {
  const mockData = [ // TODO: interfaces
    {
      "name": "28312 - Street 321, 9876 North Ida Drive",
      "requestedAmount": 27891.32,
      "approvedAmount": 27891.32,
      "inspectionScheduled": "Approved (Inspection Completed)"
    },
    {
      "name": "28312 - Street 321, 9876 North Ida Drive",
      "requestedAmount": 27891.32,
      "approvedAmount": 27891.32,
      "inspectionScheduled": "Approved (Inspection Completed)"
    },
    {
      "name": "28312 - Street 321, 9876 North Ida Drive",
      "requestedAmount": 27891.32,
      "approvedAmount": 27891.32,
      "inspectionScheduled": "Approved (Inspection Completed)"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockRequestDrawLoanInfolist = async () => {
  const mockData : IRequestDrawLoanInfo[] = [
    {
      "borrowerId": "76693908-8839-4540-bfb9-170051c28ad7",
      "borrowerName": "Johnny Depp",
      "display": "98765 - Test Project A",
      "id": "2852075b-b475-4f03-a175-a8d158a35c84",
      "loanNumber": "98765",
      "loanProperties": [
        {
          "id": "0513a78f-1e84-4b99-8aff-35351cc8b70b",
          "loanId": "2852075b-b475-4f03-a175-a8d158a35c84",
          "display": "1111 - N 1A Ave"
        },
        {
          "id": "7db2a23f-d2a7-48a2-a2db-e7d5a00354c6",
          "loanId": "2852075b-b475-4f03-a175-a8d158a35c84",
          "display": "2222 - N 2B Ave"
        },
        {
          "id": "0dc9fbcc-ebda-450f-a54b-2701b249cc08",
          "loanId": "2852075b-b475-4f03-a175-a8d158a35c84",
          "display": "3333 - N 3C Ave"
        }
      ],
      "projectName": "Test Project A",
      "street": "Test Project Street",
      "subType": "test subtype A"
    },
    {
      "borrowerId": "d2ec35d0-f50c-4d5d-992b-8a3eb82578bc",
      "borrowerName": "Johnny Depp",
      "display": "12345 - Test Project B",
      "id": "7dd4823c-7415-45b1-8d7c-33bf8c94342c",
      "loanNumber": "12345",
      "loanProperties": [
        {
          "id": "1f83476c-4238-455d-a850-428eac634596",
          "loanId": "2852075b-b475-4f03-a175-a8d158a35c84",
          "display": "1211 - S 1A Ave"
        },
        {
          "id": "dd1b51c1-66b3-4197-9d92-c570411d912c",
          "loanId": "2852075b-b475-4f03-a175-a8d158a35c84",
          "display": "2211 - S 2B Ave"
        }
      ],
      "projectName": "Test Project B",
      "street": "Test B Street",
      "subType": "test subtype B"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockRequestDrawBankInfolist = async () => {
  const mockData = [
    {
      "id": "2988be18-25e2-4292-8be6-212ec9025a57",
      "display": "Bank of Testing - 01212012012"
    },
    {
      "id": "daaf847b-2b28-4740-853b-6dca14214faf",
      "display": "Testing Trust Fund - 098098098098"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const validateMockLoanDraw = async (loanPropertyId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => loanPropertyId
  });
};

const validateMockLoanDrawFail = async () => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.reject({
    error: "validate loan property error message"
  });
};

const addMockLoanDraw = async () => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockLoanDrawDetails = async () => {
  const mockData : ILoanDrawDetailObj[] = [
    {
      "loanDrawApplicationId": "1001bef5-0054-40af-8647-5c19789b57d5",
      "id": "7a80de4e-01d0-431c-a04b-a9ec4db54497",
      "category": "Z-991100 - Construction Clean Up & Dumpster",
      "subCategory": "6434 - Trash Service",
      "budgetAmount": 2707.71,
      "disbursedAmount": 748.35,
      "availableBudgetAmount": 1959.36,
      "drawRequestAmount": 0.0,
      "lastPercentWorkComplete": 28.0,
      "currentPercentWorkComplete": "",
      "hasVendor": true,
      "constructionPhaseSortOrder": 2000,
      "sortOrder": 991100,
      "percentSortOrder": 1,
      "allowedToUpdate": false,
      "directPay": false,
      "detailDirectPay": true,
      "firstDraw": 0,
      "percentInspectionCompleteHardCost": 47.77,
      "approvalCriteria": "",
      "approvalOption": "NonDirectPayAllDraws",
      "availableWithoutInspection": 199.35
    },
    {
      "loanDrawApplicationId": "1001bef5-0054-40af-8647-5c19789b57d5",
      "id": "efae41fd-9649-4d4d-a5df-f584a3bfe214",
      "category": "Z-991300 - Excavation, Grade, Fill",
      "subCategory": "7472 - Fine Grade",
      "budgetAmount": 750.0,
      "disbursedAmount": 0.0,
      "availableBudgetAmount": 750.0,
      "drawRequestAmount": 0.0,
      "lastPercentWorkComplete": "",
      "currentPercentWorkComplete": "",
      "hasVendor": false,
      "constructionPhaseSortOrder": 2000,
      "sortOrder": 991300,
      "percentSortOrder": 1,
      "allowedToUpdate": false,
      "directPay": false,
      "detailDirectPay": false,
      "firstDraw": 0,
      "percentInspectionCompleteHardCost": 47.77,
      "approvalCriteria": "",
      "approvalOption": "NonDirectPayAllDraws",
      "availableWithoutInspection": 0.0
    },
    {
      "loanDrawApplicationId": "1001bef5-0054-40af-8647-5c19789b57d5",
      "id": "5632acc8-f457-4632-89f2-fb4f241cb4cc",
      "category": "Z-993400 - Exterior Concrete (Steps, Walks, Driveway)",
      "subCategory": "8581 - Flatwork - Exterior",
      "budgetAmount": 10469.86,
      "disbursedAmount": 10469.86,
      "availableBudgetAmount": 0.0,
      "drawRequestAmount": 0.0,
      "lastPercentWorkComplete": 100.0,
      "currentPercentWorkComplete": "",
      "hasVendor": false,
      "constructionPhaseSortOrder": 17000,
      "sortOrder": 993400,
      "percentSortOrder": 2,
      "allowedToUpdate": false,
      "directPay": false,
      "detailDirectPay": false,
      "firstDraw": 0,
      "percentInspectionCompleteHardCost": 47.77,
      "approvalCriteria": "",
      "approvalOption": "NonDirectPayAllDraws",
      "availableWithoutInspection": 0.0
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanDetailVendors = async () => {
  const mockData = [
    {
      "loanDrawApplication_DetailId": "7a80de4e-01d0-431c-a04b-a9ec4db54497",
      "id": "80085761-d193-43db-acf0-7e74a2a4d1e2",
      "vendorName": "Bev the Gardener",
      "referenceNo": "111111",
      "drawRequestAmount": 2.0,
      "address": "",
      "city": "",
      "state": "",
      "zip": "",
      "paidToVendor": true,
      "email": "",
      "requiresApprovalForPayment": false,
      "allowedToUpdate": true,
      "isNewRow": true
    },
    {
      "loanDrawApplication_DetailId": "7a80de4e-01d0-431c-a04b-a9ec4db54497",
      "id": "82ccfb0d-80d4-45d6-acc2-e42cd1480bf2",
      "vendorName": "Bev Architectural Group, Inc.",
      "referenceNo": "22222",
      "drawRequestAmount": 3333.0,
      "address": "",
      "city": "",
      "state": "",
      "zip": "",
      "paidToVendor": true,
      "email": "",
      "requiresApprovalForPayment": false,
      "allowedToUpdate": true,
      "isNewRow": true
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockBorrowerVendorList = async () => {
  const mockData : IBorrowerVenderObj[] = [
    {
      "id": "80085761-d193-43db-acf0-7e74a2a4d1e2",
      "borrower_OrganizationId": "f4249f1b-266d-474c-8464-9e58c4c10b6b",
      "borrower_Organization": "Bev Test Borrower, LLC",
      "name": "Bev the Gardener",
      "address": "Gardener Street",
      "city": "Seattle",
      "state": "Washington",
      "zip": "98123",
      "email": "",
      "allowSendInviteId": true,
      "hasUserLoggedInId": ""
    },
    {
      "id": "0467873e-199e-470a-b612-2ceed52e8d02",
      "borrower_OrganizationId": "f4249f1b-266d-474c-8464-9e58c4c10b6b",
      "borrower_Organization": "Bev Test Borrower, LLC",
      "name": "Engineering & Const LLC",
      "address": "123 Engineering Trail",
      "city": "Seattle",
      "state": "Washington",
      "zip": "98122",
      "email": "test@engineering.test",
      "allowSendInviteId": true,
      "hasUserLoggedInId": ""
    },
    {
      "id": "2bd4ce4c-e77e-4104-a86d-8d82e86ad35b",
      "borrower_OrganizationId": "f4249f1b-266d-474c-8464-9e58c4c10b6b",
      "borrower_Organization": "Bev Test Borrower, LLC",
      "name": "Bev Selling Glass",
      "address": "123 Glass Place",
      "city": "Seattle",
      "state": "Washington",
      "zip": "98121",
      "email": "selling@glass.comuat",
      "allowSendInviteId": true,
      "hasUserLoggedInId": "4abe8738-0fb7-40ca-bc64-abbc0147599b"
    },
    {
      "id": "82ccfb0d-80d4-45d6-acc2-e42cd1480bf2",
      "borrower_OrganizationId": "f4249f1b-266d-474c-8464-9e58c4c10b6b",
      "borrower_Organization": "Bev Test Borrower, LLC",
      "name": "Bev Architectural Group, Inc.",
      "address": "Vendor Drive, Suite B",
      "city": "Seattle",
      "state": "Washington",
      "zip": "98120",
      "email": "architectural@test.comuat",
      "allowSendInviteId": true,
      "hasUserLoggedInId": "cb7c92fc-1f29-465f-bc38-ae3700ef297f"
    },
    {
      "id": "605248fe-562f-47e8-8c5d-30d0e279d9d2",
      "borrower_OrganizationId": "f4249f1b-266d-474c-8464-9e58c4c10b6b",
      "borrower_Organization": "Bev Test Borrower, LLC",
      "name": "Bev Design Company",
      "address": "Design Street N",
      "city": "Seattle",
      "state": "Washington",
      "zip": "98125",
      "email": "Design@test.couat",
      "allowSendInviteId": true,
      "hasUserLoggedInId": ""
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const addMockNewVendor = async (newVendor) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true,
    json: () => newVendor
  });
};

const deleteMockLoanDrawRequest = async () => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockLoanDrawAttachments = async () => {
  const mockData : IDrawAttachmentObj[] = [
		{
			"loanDrawApplicationId": "1001bef5-0054-40af-8647-5c19789b57d5",
			"id": "1dd196b8-bfea-4648-8f1e-8cf09cae40be",
			"attachment": "bev_test_attachment.txt",
			"attachedBy": "beverly.kwok@builders-capital.com",
			"attachedOn": "2022-06-09T10:16:17.613",
			"lockVersion": 0
		},
		{
			"loanDrawApplicationId": "1001bef5-0054-40af-8647-5c19789b57d5",
			"id": "fee3a74a-79cc-4f00-a008-452d8e4863be",
			"attachment": "test_attachment_again.txt",
			"attachedBy": "beverly.kwok@builders-capital.com",
			"attachedOn": "2022-06-09T10:16:06.793",
			"lockVersion": 0
		}
	];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const addMockLoanDrawAttachment = async (attachment) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => attachment
  });
};

const deleteMockLoanDrawAttachment = async () => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const updateMockLoanDrawApplicationDetails = async () => {
  const mockData = [
    {
      "id": "78091bfe-3067-4f57-8328-7d6da22186c8",
      "category": "Z-991100 - Construction Clean Up & Dumpster",
      "subCategory": "6434 - Trash Service",
      "vendor": "Clean up test vendor",
      "drawRequestAmount": 391.27
    },
    {
      "id": "cac8598b-ec1d-49bb-b594-86e2dd043ef3",
      "category": "Z-993400 - Exterior Concrete (Steps, Walks, Driveway)",
      "subCategory": "8581 - Flatwork - Exterior",
      "vendor": "Flatwork Vendor",
      "drawRequestAmount": 1298.82
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockHomeBorrowerStatementsInfolist = async () => {
  const mockData = [ // TODO: interfaces
    {
      "loanNumber": 51172,
      "project": "Flower Ranch - 30, 31, 32",
      "statementFor": "Februray 2022",
      "status": "active"
    },
    {
      "loanNumber": 51195,
      "project": "Flower Ranch - 36, 37, 38",
      "statementFor": "Februray 2022",
      "status": "active"
    },
    {
      "loanNumber": 52102,
      "project": "Happy Lots 12-28",
      "statementFor": "January 2022",
      "status": "inactive"
    },
    {
      "loanNumber": 52149,
      "project": "Happy Lots 37-51",
      "statementFor": "January 2022",
      "status": "active"
    },
    {
      "loanNumber": 50772,
      "project": "Tall Building A",
      "statementFor": "December 2021",
      "status": "inactive"
    },
    {
      "loanNumber": 50832,
      "project": "Tall Building B",
      "statementFor": "December 2021",
      "status": "active"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockHomePaymentsInfolist = async () => {
  const mockData : IHomePaymentsObj[] = [ // TODO: interfaces
    {
      "id": "b7c36e56-8f93-416a-b58a-943e91816c33",
      "loanId": "a2eb9074-f583-4727-b4b3-d53d797fb66e",
      "borrowerOrganizationId": "3d8fafb6-e5b7-487b-a5bd-06b366c16495",
      "loanNumber": "11297",
      "city": "Morton Grove",
      "county": "Cook",
      "state": "Illinois",
      "street": "6F49924AFF69",
      "zip": "00646",
      "transactionEffectiveDate": "2022-02-03T00:00:00",
      "transactionAmount": 2975.95,
      "isActive": true,
      "projectName": "153862ABCBEE",
      "loggedInUserAccountId": "25296e3f-6464-4e21-81e9-ac8b00d3e368"
    },
    {
      "id": "6831cbc0-6b95-4286-93a4-392e45714ca1",
      "loanId": "cbda32d4-feeb-45f3-baa0-a538ae53e31f",
      "borrowerOrganizationId": "3d8fafb6-e5b7-487b-a5bd-06b366c16495",
      "loanNumber": "12297",
      "city": "Morton Grove",
      "county": "Cook",
      "state": "Illinois",
      "street": "6F49924AFF69",
      "zip": "00646",
      "transactionEffectiveDate": "2022-02-05T00:00:00",
      "transactionAmount": 2975.95,
      "isActive": true,
      "projectName": "293862KBCHLE",
      "loggedInUserAccountId": "25296e3f-6464-4e21-81e9-ac8b00d3e368"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockHomeProjectsInfolist = async () => {
  const mockData = [
    {
      "loanNumber": 52149,
      "project": "Happy Lots 37-51",
      "status": "Inactive",
      "originalLoan": 159267196.19,
      "currentLoan": 62789123.19,
      "interestRate": 7.990,
      "maturityDate": "2021-01-15T09:36:31.777825-07:00",
      "interestReserve": 790928.82,
      "loanOfficer": "John Anderson",
      "servicingRep": "Kelly Brook"
    },
    {
      "loanNumber": 50772,
      "project": "Tall Building A",
      "status": "active",
      "originalLoan": 209267196.19,
      "currentLoan": 89763421.19,
      "interestRate": 7.990,
      "maturityDate": "2023-01-27T09:36:31.777825-07:00",
      "interestReserve": 841928.82,
      "loanOfficer": "John Anderson",
      "servicingRep": "Kelly Brook"
    },
    {
      "loanNumber": 50832,
      "project": "Tall Building B",
      "status": "active",
      "originalLoan": 219830873.19,
      "currentLoan": 99830873.19,
      "interestRate": 7.990,
      "maturityDate": "2023-02-23T09:36:31.777825-07:00",
      "interestReserve": 841928.82,
      "loanOfficer": "John Anderson",
      "servicingRep": "Kelly Brook"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockHomeBorrowerApplicationsInfolist = async () => {
  const mockData = [
    {
      "name": "Tall Building C",
      "budget": 23471073.19,
      "loanProgram": "New Construction"
    },
    {
      "name": "Tall Building D",
      "budget": 21928493.89,
      "loanProgram": "New Construction"
    },
    {
      "name": "Happy Lots 52-58",
      "budget": 13923785.28,
      "loanProgram": "New Construction"
    },
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockPaidAchPaymentsInfolist = async () => {
  const mockData : IAchPaymentsObj[] = [
    {
      "vendorName": "A234F5587C77",
      "referenceNo": "12345",
      "drawRequestAmount": 1020.00,
      "address": "FDDB980DF43E",
      "city": "Ridgefield",
      "state": "WA",
      "zip": 98133,
      "requiresApprovalForPayment": "No",
      "paidToVendor": false,
      "email": "mock1@email.com",
      "approvedAmount": 1020.00,
      "drawName": "Mock Draw Name",
      "propertyAddress": "15578CDA89F9",
      "paymentApprovedOn": "2021-01-24T09:36:31.777825-07:00",
      "drawApprovedOn": "2021-02-24T09:36:31.777825-07:00",
      "sentOn": "2021-03-24T09:36:31.777825-07:00",
      "id" : "192f1d3d-3f6f-47f3-9450-dceb69580f6c",
      "loanDrawDetailId" : "792f1d3d-3f6f-47f3-9450-0f2dc2b601a3",
      "loggedInUserAccountId" : "829jsl29-3f6f-47f3-9450-dceb69580f6c",
      "organizationId" : "230lhd19-3f6f-47f3-9450-dceb69580f6c"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockPendingApprovalInfolist = async () => {
  const mockData: IPendingApprovalObj[]  = [
    {
      "vendorName": "B534F5587C77",
      "referenceNo": "23456",
      "drawRequestAmount": 1820.00,
      "address": "AFDB980DF43E",
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "requiresApprovalForPayment": "Yes",
      "paidToVendor": false,
      "email": "mock2@email.com",
      "approvedAmount": 1820.00,
      "drawName": "Mock Draw Name",
      "propertyAddress": "28578CDA89G9",
      "id" : "192f1d3d-3f6f-47f3-9450-dceb69580f6c",
      "loanDrawDetailId" : "792f1d3d-3f6f-47f3-9450-0f2dc2b601a3",
      "loggedInUserAccountId" : "829jsl29-3f6f-47f3-9450-dceb69580f6c",
      "organizationId" : "230lhd19-3f6f-47f3-9450-dceb69580f6c"
    }
  ];
  
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockVendorInfolist = async () => {
  const mockData = [
    {
      "id": "192f1d3d-3f6f-47f3-9450-dceb69580f6c",
      "borrower": "SpiderMan",
      "name": "Vendor Name",
      "address": "2021 Good Movie St",
      "city": "Hollywood",
      "state": "CA",
      "zip": 90028,
      "email": "mock3@email.com",
    },
    {
      "id": "b43qeh03-8035-396b-0d99-7f2dc8b609b3",
      "borrower": "John Smith",
      "name": "Mary Johnson",
      "address": "123 Street St",
      "city": "Seattle",
      "state": "WA",
      "zip": 98101,
      "email": "mock4@email.com",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const resendMockVendorInvite = async (inviteObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inviteObj
  });
};

const getMockPayoffQuotelist = async () => {
  const mockData = [
    {
      "id": "792f1d3d-3f6f-47f3-9450-dceb69590f6c",
      "loan": "Project ABC",
      "payoffRequestVersionNumber": "3",
      "payoffRequestDate": "2021-01-20T09:36:31.777825-07:00",
      "validThroughDate": "2021-01-27T09:36:31.777825-07:00",
      "totalPayout": 130000,
      "payoutDate": "2021-01-24T09:36:31.777825-07:00",
      "loanPropertyUnitReconveyance":  "Project ABC unit A",
      "property": "payoff quote property"
    },
    {
      "id": "f43qeh83-8031-346b-0d19-7f2dc2b609a3",
      "loan": "Another loan",
      "payoffRequestVersionNumber": "2",
      "payoffRequestDate": "2021-02-10T09:36:31.777825-07:00",
      "validThroughDate": "2021-02-14T09:36:31.777825-07:00",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const createMockPayoffQuoteRequest = async (payoffQuoteRequest) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => payoffQuoteRequest
  });
};

const getMockPayoffQuoteLoanList = async () => {
  const mockData = [
    {
      "id": "392f1d3d-3f9f-47f3-9450-dceb69592f6c",
      "loan": "Project ABC",
      "loanPropertyUnitReconveyance":  [
        { 
          "name": "Project ABC unit A",
          "paidOff": true
        },
        { "name": "Project ABC unit B",
          "paidOff": false
        },
        { "name": "Project ABC unit C",
          "paidOff": false
        },
        { "name": "Project ABC unit D",
          "paidOff": true
        }
      ]
    },
    {
      "id": "f41qeh53-7031-346b-0d19-0f2dc2b601a3",
      "loan": "Another loan",
      "loanPropertyUnitReconveyance":  [
        { "name": "Another loan unit A",
          "paidOff": true
        }
      ]
    },
    {
      "id": "k48qeh53-7931-346d-0c19-0f2dc2t601a3",
      "loan": "So much loan"
    },
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockProjectsInfolist = async () => {
  const mockData = [
    {
      "id": "k43qeh03-8015-396b-0d39-7f2dc8b609b3",
      "loanProperty": "Loan Property A",
      "loanNumber": 98765,
      "projectNumber": 65432,
      "createdOn": "2021-01-27T09:36:31.777825-07:00",
      "city": "Seattle",
      "state": "WA",
      "zip": "98101",
      "county": "King",
      "projectName": "A project",
      "propertyType": "type a",
      "borrower": "borrower a",
      "borrowerContact": "company a",
      "borrowerPhoneNumber": "2061230000",
      "tcName": "TC A",
      "tcPhoneNumber": "2061112222",
      "builder": "Builder A",
      "builderEmail": "builda@email.com",
      "builderPhoneNumber": "4251112222",
    },
    {
      "id": "p43qeh03-2015-396b-0d38-7f2dc8b609b3",
      "loanProperty": "Loan Property B",
      "loanNumber": 22223,
      "projectNumber": 44445,
      "createdOn": "2021-02-07T09:36:31.777825-07:00",
      "city": "Shoreline",
      "state": "WA",
      "zip": "98133",
      "county": "King",
      "projectName": "B project",
      "propertyType": "type b",
      "borrower": "borrower b",
      "borrowerContact": "company b",
      "borrowerPhoneNumber": "2061233333",
      "tcName": "TC B",
      "tcPhoneNumber": "2060002222",
      "builder": "Builder B",
      "builderEmail": "buildb@email.com",
      "builderPhoneNumber": "4253332222",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const updateMockInspectionScheduleDate = async (inspectionObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inspectionObj
  });
};

const getMockCurrentInspectionsInfolist = async () => {
  const mockData = [
    {
      "id": "e43qeh03-2015-396b-0a38-7f2dc8b609b3",
      "loanDraw": "January 2022 - 60",
      "inspectionNumber": 6721,
      "inspectionStatus": "Requested",
      "scheduleDate": "2021-02-08T09:36:31.777825-07:00",
      "inspectedOn": "2021-02-01T09:36:31.777825-07:00",
      "completedOn": "2021-02-02T09:36:31.777825-07:00",
      "createdOn": "2021-02-07T09:36:31.777825-07:00",
      "updatedOn": "2021-02-07T09:36:31.777825-09:00",
      "updatedBy": "a@update.com",
      "property": "123 Street",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2021-02-04T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "builderEmail": "b@builder.com",
      "builderPhoneNumber": "3334445555",
      "inspectionCompany": "NWM",
      "description": "This is the description",
    },
    {
      "id": "k43geh03-9273-396a-0d32-7f2dc8b609e3",
      "loanDraw": "January 2022 - 30",
      "inspectionNumber": 8121,
      "inspectionStatus": "Requested",
      "createdOn": "2021-01-07T09:36:31.777825-07:00",
      "property": "Cat Street",
      "projectNumber": 3524,
      "loanNumber": 92345,
      "city": "Seattle",
      "state": "WA",
      "zip": 98105,
      "county": "King",
      "projectName": "Catch Jerry",
      "propertyType": "Townhome",
      "borrowerContact": "Jerry Mouse",
      "borrowerPhoneNumber": "1110003333",
      "tcName": "Tom Cat",
      "tcPhoneNumber": "2220004444",
      "requestedDate": "2021-02-04T09:36:31.777825-07:00",
      "borrower": "Z Company",
      "builder": "Z Company",
      "inspectionCompany": "NWM"
    },
    {
      "id": "a43geh03-9273-396a-0d02-7f2dc8b609e3",
      "loanDraw": "January 2022 - 30",
      "inspectionNumber": 8121,
      "inspectionStatus": "Requested",
      "createdOn": "2021-01-07T09:36:31.777825-07:00",
      "property": "Cat Street",
      "projectNumber": 3524,
      "loanNumber": 92345,
      "city": "Seattle",
      "state": "WA",
      "zip": 98105,
      "county": "King",
      "projectName": "Catch Jerry",
      "propertyType": "Townhome",
      "borrowerContact": "Jerry Mouse",
      "borrowerPhoneNumber": "1110003333",
      "tcName": "Tom Cat",
      "tcPhoneNumber": "2220004444",
      "requestedDate": "2021-02-04T09:36:31.777825-07:00",
      "borrower": "Z Company",
      "builder": "Z Company",
      "inspectionCompany": "NWM"
    },
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockCurrentWorkInspectionInfo = async () => {
  const mockData = {
    "inspectionNo": "8947",
    "loanProperty": "1239 - Project ABC unit A",
    "loanDraw": "March 2021 - 3",
    "submittedOn": "2021-01-24T09:36:31.777825-07:00",
    "inspectionStatus": "Requested",
    "tCInfo": "Sam Steed",
    "project": "Lot 123 - A Village 2",
    "document": "This.xlsx",
    "requestedDate": "2021-01-27T09:36:31.777825-07:00",
    "scheduleDate": "2021-01-29T09:36:31.777825-07:00",
    "inspectedOn": "2021-02-12T09:36:31.777825-07:00",
    "details": [
      {
        "lineNumber": 11,
        "cumulativePercentComplete": 0.00,
        "comments": "",
        "category": "Electrical & Light Fixture",
        "subCategory": "",
        "budgetAmount": 1200.00,
        "previousCumulativePercent": 0

      },
      {
        "lineNumber": 29,
        "cumulativePercentComplete": 0.00,
        "comments": "",
        "category": "Roofing",
        "subCategory": "",
        "budgetAmount": 2900.00,
        "previousCumulativePercent": 0

      }
    ],
    "documents": []
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const updateMockCurrentInspection = async (inspection) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inspection
  });
};

const getMockCurrentWorkInspectionDetailInfo = async () => {
  const mockData = [
    {
      "budgetAmount": 900,
      "category": "Engineering (Soft Cost)",
      "comment": null,
      "cumulativePercentComplete": 50,
      "editableOnGridId": 0,
      "id": "a2bff2fd-300d-42fd-97e9-e3eb90c22c69",
      "lineNumber": 5,
      "loanBudgetSubCategory": "3-01-1111 - Site Spec Engin",
      "lockVersion": 0,
      "nwccinspectionId": "62991306-4b08-47e1-91be-2cf31b7a8caa",
      "previousCumulativePercent": 30
    },
    {
      "budgetAmount": 175,
      "category": "Engineering (Soft Cost)",
      "comment": null,
      "cumulativePercentComplete": 100,
      "editableOnGridId": 0,
      "id": "742964c2-b959-4947-bb88-07d1c934133e",
      "lineNumber": 6,
      "loanBudgetSubCategory": "3-01-1170 - Perimeter Drain Observation",
      "lockVersion": 0,
      "nwccinspectionId": "62991306-4b08-47e1-91be-2cf31b7a8caa",
      "previousCumulativePercent": 100
    },
    {
      "budgetAmount": 12185,
      "category": "Windows/Sliders",
      "comment": null,
      "cumulativePercentComplete": 100,
      "editableOnGridId": 0,
      "id": "ec49f4b1-14a6-48cb-bca5-e6367fd02031",
      "lineNumber": 7,
      "loanBudgetSubCategory": "3-04-4510 - Window Exter Doors - Tunkey",
      "lockVersion": 0,
      "nwccinspectionId": "62991306-4b08-47e1-91be-2cf31b7a8caa",
      "previousCumulativePercent": 100
    },
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const downloadMockWorkInspectionDocument = async (nwccinspectionId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => nwccinspectionId
  });
};

const updateMockCurrentInspectionDetails = async (inspectionList) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inspectionList
  });
};

const completeMockCurrentInspection = async (inspectionId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inspectionId
  });
};

const updateMockInspectionDetailList = async (inspectionList) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => inspectionList
  });
};

const getMockRequestedInspectionsInfolist = async () => {
  const mockData = [
    {
      "loanNumber": 98765,
      "street": "1 Street",
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "requestedDate": "2021-02-04T09:36:31.777825-07:00",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "loanContact": "John Smith",
      "loanContactNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "builderEmail": "b@builder.com",
      "builderPhoneNumber": "3334445555",
    },
    {
      "loanNumber": 45123,
      "street": "90 Happy St",
      "city": "Burien",
      "state": "WA",
      "zip": 18146,
      "county": "King",
      "requestedDate": "2021-05-04T09:36:31.777825-07:00",
      "projectName": "First project",
      "propertyType": "Townhome",
      "loanContact": "Ben Hendersons",
      "loanContactNumber": "8182223333",
      "tcName": "Mike Wilson",
      "tcPhoneNumber": "8887771111",
      "borrower": "Mike's Company",
      "builder": "Mike's Company",
      "builderEmail": "mike@builder.com",
      "builderPhoneNumber": "9091234567",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockPastInspectionsInfolist = async () => {
  const mockData = [
    {
      "loanDraw": "Oct 2021 - 2110",
      "inspectionNumber": 1111,
      "inspectedOn": "2021-10-01T09:36:31.777825-07:00",
      "completedOn": "2021-10-02T09:36:31.777825-07:00",
      "property": "10 Street",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2021-09-01T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "builderEmail": "b@builder.com",
      "builderPhoneNumber": "3334445555",
      "scheduleDate": "2021-09-02T09:36:31.777825-07:00",
      "description": "This is the description",
    },
    {
      "loanDraw": "Nov 2021 - 2111",
      "inspectionNumber": 2222,
      "inspectedOn": "2021-11-01T09:36:31.777825-07:00",
      "completedOn": "2021-11-02T09:36:31.777825-07:00",
      "property": "11 Street",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2021-10-01T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "builderEmail": "b@builder.com",
      "builderPhoneNumber": "3334445555",
      "scheduleDate": "2021-10-02T09:36:31.777825-07:00",
      "description": "This is the description",
    },
    {
      "loanDraw": "Dec 2021 - 2112a",
      "inspectionNumber": 3333,
      "inspectedOn": "2021-12-01T09:36:31.777825-07:00",
      "completedOn": "2021-12-02T09:36:31.777825-07:00",
      "property": "12 Street A",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2021-11-01T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "builderEmail": "b@builder.com",
      "builderPhoneNumber": "3334445555",
      "scheduleDate": "2021-11-02T09:36:31.777825-07:00",
      "description": "This is the description",
    },
    {
      "loanDraw": "Dec 2021 - 2112b",
      "inspectionNumber": 4444,
      "inspectedOn": "2021-12-04T09:36:31.777825-07:00",
      "completedOn": "2021-12-05T09:36:31.777825-07:00",
      "property": "12 Street B",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2021-11-11T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "scheduleDate": "2021-11-22T09:36:31.777825-07:00",
      "description": "This is the description",
    },
    {
      "loanDraw": "Jan 2022 - 2201",
      "inspectionNumber": 5555,
      "inspectedOn": "2022-01-12T09:36:31.777825-07:00",
      "completedOn": "2022-01-13T09:36:31.777825-07:00",
      "property": "221 Street",
      "projectNumber": 1224,
      "loanNumber": 98765,
      "city": "Seattle",
      "state": "WA",
      "zip": 98102,
      "county": "King",
      "projectName": "Unit A",
      "propertyType": "Single Family",
      "borrowerContact": "John Smith",
      "borrowerPhoneNumber": "1112223333",
      "tcName": "Ann Lee",
      "tcPhoneNumber": "2223334444",
      "requestedDate": "2022-01-01T09:36:31.777825-07:00",
      "borrower": "ABC Company",
      "builder": "ABC Company",
      "scheduleDate": "2022-01-02T09:36:31.777825-07:00",
      "description": "This is the description",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockInspectionProjectDetails = async () => {
  const mockData = [
    {
      "budgetAmount": 3000,
      "category": "Foundation",
      "id": "d70c5257-77aa-4500-956c-08d3ed345d8e",
      "lineNumber": 5,
      "loanBudgetSubCategory": "Interior Slab Labor",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b"
    },
    {
      "budgetAmount": 1000,
      "category": "Flooring",
      "id": "a3af3812-3a4a-450d-aaa5-4f6a6a6e3acd",
      "lineNumber": 6,
      "loanBudgetSubCategory": "Tile Material",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b"
    },
    {
      "budgetAmount": 2000,
      "category": "Cabinets",
      "id": "8711a5f9-0941-4405-a12b-610562ec7bc8",
      "lineNumber": 7,
      "loanBudgetSubCategory": "Kitchen Cabinets",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockInspectionProjectDocuments = async () => {
  const mockData = [
    {
      "id": "df239746-a232-4492-aeea-86765ddeb35f",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b",
      "createdBy": "testing@builder.com",
      "createdOn": "2020-10-13T09:13:12.723",
      "documentFileName": "testing_document.pdf",
      "documentLogId": "5ed39192-7ebd-4fc8-976b-ac1e012aabbc",
    },
    {
      "id": "7a9e3b07-2b2b-4a75-90a8-711da6443867",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b",
      "createdBy": "testing@builder.com",
      "createdOn": "2020-10-13T09:13:12.723",
      "documentFileName": "inspection_report.pdf",
      "documentLogId": "5ed39192-7ebd-4fc8-976b-ac1e012aabbc",
    },
    {
      "id": "a99cfab7-8c8b-4b0e-8c5b-10f20c7f0958",
      "nwccprojectId": "192f1d3d-18ce-4ac9-8b68-224c0e84248b",
      "createdBy": "testing@builder.com",
      "createdOn": "2020-10-13T09:13:12.723",
      "documentFileName": "checklist.pdf",
      "documentLogId": "5ed39192-7ebd-4fc8-976b-ac1e012aabbc",
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockInspectionProjectInspections = async () => {
  const mockData = [
    {
      "allowEditId": false,
      "borrower": "5590BFF9DD90",
      "borrowerContact": "69C6AB27B984 F7972D60BD5D",
      "borrowerContactPhone": "57",
      "builder": "3D4849781200",
      "builderEmail": null,
      "builderPhone": null,
      "city": "Grand Prairie",
      "completedOn": "2020-10-15T17:48:31.533",
      "county": "Dallas",
      "createdOn": "2020-10-02T23:00:44.43",
      "dateInspected": "2020-10-12T00:00:00",
      "description": "deleted",
      "id": "9243bd42-a4e8-4d7e-a34a-7af02cd603a7",
      "inspectionCompany": "2D8506DD90",
      "inspectionNo": 204,
      "inspectionStatus": "Completed",
      "loanDraw": "October 2020 - 10",
      "loanDrawStatusNameId": "Funded",
      "loanNumber": "71627",
      "nwccprojectId": "3a42f569-18ce-4ac9-8b68-224c0e84248b",
      "projectName": "8176E9D232EB",
      "projectNo": 9,
      "property": "6270EAC442B2",
      "propertyType": "Single Family",
      "requestedDate": "2020-10-12T00:00:00",
      "scheduleDate": null,
      "state": "TX",
      "tcname": "Miranda Schwab",
      "tcphoneNumber": "92",
      "updatedBy": "deleted",
      "updatedOn": "2020-10-15T17:48:31.537",
      "workInspectionCompanyOrganizationId": "b18a2e26-d1e8-4fd3-a6c2-ac2a0050328c",
      "zip": "00674"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

export {
  getMockHomeDrawRequestsInfolist,
  getMockRequestDrawLoanInfolist,
  getMockRequestDrawBankInfolist,
  validateMockLoanDraw,
  validateMockLoanDrawFail,
  addMockLoanDraw,
  getMockLoanDrawDetails,
  getMockLoanDetailVendors,
  getMockBorrowerVendorList,
  addMockNewVendor,
  deleteMockLoanDrawRequest,
  getMockLoanDrawAttachments,
  addMockLoanDrawAttachment,
  deleteMockLoanDrawAttachment,
  updateMockLoanDrawApplicationDetails,
  getMockHomeBorrowerStatementsInfolist,
  getMockHomePaymentsInfolist,
  getMockHomeProjectsInfolist,
  getMockHomeBorrowerApplicationsInfolist,
  getMockPaidAchPaymentsInfolist,
  getMockPendingApprovalInfolist,
  getMockVendorInfolist,
  resendMockVendorInvite,
  getMockPayoffQuotelist,
  createMockPayoffQuoteRequest,
  getMockPayoffQuoteLoanList,
  getMockProjectsInfolist,
  getMockCurrentInspectionsInfolist,
  getMockCurrentWorkInspectionInfo,
  downloadMockWorkInspectionDocument,
  updateMockInspectionScheduleDate,
  updateMockCurrentInspection,
  getMockCurrentWorkInspectionDetailInfo,
  updateMockCurrentInspectionDetails,
  completeMockCurrentInspection,
  updateMockInspectionDetailList,
  getMockRequestedInspectionsInfolist,
  getMockPastInspectionsInfolist,
  getMockInspectionProjectDetails,
  getMockInspectionProjectDocuments,
  getMockInspectionProjectInspections
};